import React from 'react'
import { CLOUDINARY_URL } from '../services/helper'

function NotFound() {
  return (
    <section className='notfound-section'>
        <img src={`${CLOUDINARY_URL}/404-2.gif`} alt="" />
    </section>
  )
}

export default NotFound